import { S as e, T as t, _ as n, a as r, b as ee, c as te, d as ne, f as i, g as a, h as o, i as s, l as c, m as l, n as u, o as re, p as ie, r as ae, s as oe, t as se, u as ce, v as le, w as ue, x as de, y as fe } from "./sdk.gen-CV5NlfXb.js";
import { c as pe, i as d, l as me, r as f, s as he, t as ge, u as _e } from "./dist-Cy52Qw2K.js";
import { t as ve } from "./useProductService-dO456Fzw.js";
//#region \0rolldown/runtime.js
var p = Object.defineProperty, ye = (e, t) => {
	let n = {};
	for (var r in e) p(n, r, {
		get: e[r],
		enumerable: !0
	});
	return t || p(n, Symbol.toStringTag, { value: "Module" }), n;
}, be = {
	type: "string",
	enum: ["VASCO"],
	description: "The fulfilment platform."
}, xe = {
	type: "string",
	enum: ["status"]
}, Se = {
	type: "string",
	format: "uuid"
}, Ce = {
	type: "string",
	enum: ["ACTIVE", "INACTIVE"],
	description: "The status of the product."
}, we = {
	type: "string",
	minLength: 1,
	maxLength: 50
}, Te = {
	type: "string",
	enum: ["ASC", "DESC"],
	description: "The sort direction."
}, Ee = {
	type: "object",
	additionalProperties: {
		type: "object",
		properties: {
			free: {
				type: "integer",
				minimum: -9007199254740991,
				maximum: 9007199254740991,
				description: "The amount of free stock of the product."
			},
			value: {
				type: "integer",
				minimum: 0,
				maximum: 9007199254740991,
				description: "The amount of stock of the product."
			}
		},
		required: ["free", "value"]
	},
	propertyNames: { $ref: "#/components/schemas/FulfilmentPlatform" }
}, De = {
	type: "object",
	properties: {
		id: { allOf: [{ $ref: "#/components/schemas/ProductId" }, { description: "The ID of the product." }] },
		createdAt: {
			type: "string",
			format: "date-time",
			description: "The datetime the product was created"
		},
		name: {
			type: "string",
			minLength: 1,
			maxLength: 250,
			description: "The name of the product."
		},
		shopIds: {
			type: "array",
			items: { $ref: "#/components/schemas/ShopId" },
			maxItems: 500
		},
		status: { $ref: "#/components/schemas/ProductStatus" },
		trackInventory: {
			type: "boolean",
			description: "Whether the product its inventory should be tracked."
		},
		barcode: {
			type: "string",
			minLength: 6,
			maxLength: 24,
			description: "The barcode of the product."
		},
		children: {
			type: "array",
			items: {
				type: "object",
				properties: {
					id: { allOf: [{ $ref: "#/components/schemas/ProductId" }, { description: "The ID of the product." }] },
					quantity: {
						type: "integer",
						minimum: 1,
						maximum: 1e3,
						description: "The quantity of the product in the parent product."
					}
				},
				required: ["id", "quantity"]
			},
			maxItems: 50
		},
		containsDangerousSubstances: {
			type: "boolean",
			description: "Whether the product contains dangerous substances."
		},
		countryCodeOfOrigin: {
			type: "string",
			enum: /* @__PURE__ */ "AD.AE.AF.AG.AI.AL.AM.AO.AQ.AR.AS.AT.AU.AW.AX.AZ.BA.BB.BD.BE.BF.BG.BH.BI.BJ.BL.BM.BN.BO.BQ.BR.BS.BT.BV.BW.BY.BZ.CA.CC.CD.CF.CG.CH.CI.CK.CL.CM.CN.CO.CR.CU.CV.CW.CX.CY.CZ.DE.DJ.DK.DM.DO.DZ.EC.EE.EG.EH.ER.ES.ET.FI.FJ.FK.FM.FO.FR.GA.GB.GD.GE.GF.GG.GH.GI.GL.GM.GN.GP.GQ.GR.GS.GT.GU.GW.GY.HK.HM.HN.HR.HT.HU.ID.IE.IL.IM.IN.IO.IQ.IR.IS.IT.JE.JM.JO.JP.KE.KG.KH.KI.KM.KN.KP.KR.KW.KY.KZ.LA.LB.LC.LI.LK.LR.LS.LT.LU.LV.LY.MA.MC.MD.ME.MF.MG.MH.MK.ML.MM.MN.MO.MP.MQ.MR.MS.MT.MU.MV.MW.MX.MY.MZ.NA.NC.NE.NF.NG.NI.NL.NO.NP.NR.NU.NZ.OM.PA.PE.PF.PG.PH.PK.PL.PM.PN.PR.PS.PT.PW.PY.QA.RE.RO.RS.RU.RW.SA.SB.SC.SD.SE.SG.SH.SI.SJ.SK.SL.SM.SN.SO.SR.SS.ST.SV.SX.SY.SZ.TC.TD.TF.TG.TH.TJ.TK.TL.TM.TN.TO.TR.TT.TV.TW.TZ.UA.UG.UM.US.UY.UZ.VA.VC.VE.VG.VI.VN.VU.WF.WS.XK.YE.YT.ZA.ZM.ZW".split("."),
			description: "The country code of origin of the product."
		},
		descriptions: {
			type: "array",
			items: {
				type: "object",
				properties: {
					text: {
						type: "string",
						minLength: 1,
						maxLength: 2500,
						description: "The text of one of the product descriptions."
					},
					languageCode: {
						type: "string",
						minLength: 2,
						maxLength: 2,
						description: "The language code (ISO 639-1) of one of the product descriptions."
					}
				},
				required: ["text", "languageCode"]
			},
			minItems: 1,
			maxItems: 200,
			description: "The descriptions of the product."
		},
		dimensions: {
			type: "object",
			properties: {
				height: {
					type: "object",
					properties: {
						value: {
							type: "integer",
							minimum: 0,
							description: "The length value in provided unit."
						},
						unit: {
							type: "string",
							enum: [
								"mm",
								"cm",
								"m"
							],
							description: "The length unit of the provided value."
						}
					},
					required: ["value", "unit"],
					description: "The height of the product."
				},
				length: {
					type: "object",
					properties: {
						value: {
							type: "integer",
							minimum: 0,
							description: "The length value in provided unit."
						},
						unit: {
							type: "string",
							enum: [
								"mm",
								"cm",
								"m"
							],
							description: "The length unit of the provided value."
						}
					},
					required: ["value", "unit"],
					description: "The length of the product."
				},
				weight: {
					type: "object",
					properties: {
						value: {
							type: "integer",
							minimum: 0,
							description: "The weight value in provided unit."
						},
						unit: {
							type: "string",
							enum: ["g", "kg"],
							description: "The weight unit of the provided value."
						}
					},
					required: ["value", "unit"],
					description: "The weight of the product."
				},
				width: {
					type: "object",
					properties: {
						value: {
							type: "integer",
							minimum: 0,
							description: "The length value in provided unit."
						},
						unit: {
							type: "string",
							enum: [
								"mm",
								"cm",
								"m"
							],
							description: "The length unit of the provided value."
						}
					},
					required: ["value", "unit"],
					description: "The width of the product."
				}
			},
			required: [
				"height",
				"length",
				"weight",
				"width"
			],
			description: "The dimensions of the product."
		},
		ean: {
			type: "string",
			description: "The EAN of the product."
		},
		fulfilmentPlatforms: {
			type: "array",
			items: { $ref: "#/components/schemas/FulfilmentPlatform" },
			minItems: 1,
			maxItems: 1,
			description: "The fulfilment platforms the product is available on."
		},
		hasUnlimitedShelfLife: {
			type: "boolean",
			description: "Whether the product has an unlimited shelf life."
		},
		hsCode: {
			type: "string",
			minLength: 6,
			maxLength: 10,
			description: "The HS code of the product."
		},
		parents: {
			type: "array",
			items: { allOf: [{ $ref: "#/components/schemas/ProductId" }, { description: "The ID of the product." }] },
			minItems: 1,
			maxItems: 100
		},
		purchasePrice: {
			type: "object",
			properties: {
				currency: {
					type: "string",
					minLength: 3,
					maxLength: 3
				},
				micros: {
					type: "integer",
					minimum: 0,
					maximum: 9007199254740991
				}
			},
			required: ["currency", "micros"],
			description: "The purchase price of the product, excluding VAT. When micros is provided it is treated as the canonical value."
		},
		salesChannels: {
			type: "array",
			items: { oneOf: [
				{
					type: "object",
					properties: {
						sourceId: {
							type: "string",
							minLength: 1,
							maxLength: 250,
							description: "The product ID in the e-commerce platform."
						},
						salesChannelId: {
							type: "string",
							minLength: 1,
							maxLength: 50,
							description: "The sales channel ID of the e-commerce platform."
						},
						ecommercePlatformName: {
							type: "string",
							enum: ["bol"]
						}
					},
					required: [
						"sourceId",
						"salesChannelId",
						"ecommercePlatformName"
					]
				},
				{
					type: "object",
					properties: {
						sourceId: {
							type: "string",
							minLength: 1,
							maxLength: 250,
							description: "The product ID in the e-commerce platform."
						},
						salesChannelId: {
							type: "string",
							minLength: 1,
							maxLength: 50,
							description: "The sales channel ID of the e-commerce platform."
						},
						ecommercePlatformName: {
							type: "string",
							enum: ["cscart"]
						}
					},
					required: [
						"sourceId",
						"salesChannelId",
						"ecommercePlatformName"
					]
				},
				{
					type: "object",
					properties: {
						sourceId: {
							type: "string",
							minLength: 1,
							maxLength: 250,
							description: "The product ID in the e-commerce platform."
						},
						salesChannelId: {
							type: "string",
							minLength: 1,
							maxLength: 50,
							description: "The sales channel ID of the e-commerce platform."
						},
						ecommercePlatformName: {
							type: "string",
							enum: ["lightspeed"]
						}
					},
					required: [
						"sourceId",
						"salesChannelId",
						"ecommercePlatformName"
					]
				},
				{
					type: "object",
					properties: {
						sourceId: {
							type: "string",
							minLength: 1,
							maxLength: 250,
							description: "The product ID in the e-commerce platform."
						},
						salesChannelId: {
							type: "string",
							minLength: 1,
							maxLength: 50,
							description: "The sales channel ID of the e-commerce platform."
						},
						ecommercePlatformName: {
							type: "string",
							enum: ["magento"]
						}
					},
					required: [
						"sourceId",
						"salesChannelId",
						"ecommercePlatformName"
					]
				},
				{
					type: "object",
					properties: {
						sourceId: {
							type: "string",
							minLength: 1,
							maxLength: 250,
							description: "The product ID in the e-commerce platform."
						},
						salesChannelId: {
							type: "string",
							minLength: 1,
							maxLength: 50,
							description: "The sales channel ID of the e-commerce platform."
						},
						ecommercePlatformName: {
							type: "string",
							enum: ["presta"]
						}
					},
					required: [
						"sourceId",
						"salesChannelId",
						"ecommercePlatformName"
					]
				},
				{
					type: "object",
					properties: {
						sourceId: {
							type: "string",
							minLength: 1,
							maxLength: 250,
							description: "The product ID in the e-commerce platform."
						},
						salesChannelId: {
							type: "string",
							minLength: 1,
							maxLength: 50,
							description: "The sales channel ID of the e-commerce platform."
						},
						ecommercePlatformName: {
							type: "string",
							enum: ["shopify"]
						},
						inventoryItemId: {
							type: "string",
							minLength: 1,
							maxLength: 250,
							description: "The inventory item ID in shopify."
						},
						inventoryLocationId: {
							type: "string",
							minLength: 1,
							maxLength: 250,
							description: "The location id of the product in shopify"
						}
					},
					required: [
						"sourceId",
						"salesChannelId",
						"ecommercePlatformName"
					]
				},
				{
					type: "object",
					properties: {
						sourceId: {
							type: "string",
							minLength: 1,
							maxLength: 250,
							description: "The product ID in the e-commerce platform."
						},
						salesChannelId: {
							type: "string",
							minLength: 1,
							maxLength: 50,
							description: "The sales channel ID of the e-commerce platform."
						},
						ecommercePlatformName: {
							type: "string",
							enum: ["woocommerce"]
						}
					},
					required: [
						"sourceId",
						"salesChannelId",
						"ecommercePlatformName"
					]
				}
			] },
			description: "References to the sales channels per e-commerce platform."
		},
		salesPrice: {
			type: "object",
			properties: {
				currency: {
					type: "string",
					minLength: 3,
					maxLength: 3
				},
				micros: {
					type: "integer",
					minimum: 0,
					maximum: 9007199254740991
				},
				taxRate: {
					type: "integer",
					minimum: 0,
					maximum: 100
				}
			},
			required: [
				"currency",
				"micros",
				"taxRate"
			],
			description: "The sales price of the product, including VAT. When micros is provided it is treated as the canonical value."
		},
		sku: {
			type: "string",
			minLength: 1,
			maxLength: 200,
			description: "The SKU of the product."
		},
		stock: { $ref: "#/components/schemas/Stock" },
		updatedAt: {
			type: "string",
			format: "date-time",
			description: "The datetime the product was last updated."
		}
	},
	required: [
		"id",
		"createdAt",
		"name",
		"status",
		"trackInventory"
	]
}, Oe = {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: [
				"about:blank",
				"urn:problem:client",
				"urn:problem:invalid-request-syntax",
				"urn:problem:not-found",
				"urn:problem:server",
				"urn:problem:unauthorized",
				"urn:problem:unsupported-media-type"
			],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "integer",
			enum: [
				400,
				401,
				404,
				415,
				500
			],
			description: "The HTTP status code generated by the origin server."
		},
		title: {
			type: "string",
			minLength: 1,
			maxLength: 100,
			description: "A short human-readable summary of the problem type."
		},
		detail: {
			type: "string",
			minLength: 1,
			maxLength: 5e3,
			description: "A human-readable explanation specific to this occurrence of the problem."
		},
		instance: {
			type: "string",
			format: "uri",
			description: "A URI reference that identifies the specific occurrence of the problem."
		},
		cause: { description: "The cause of this problem when debug mode is enabled." }
	},
	required: [
		"type",
		"status",
		"title",
		"detail",
		"instance"
	]
}, m = { allOf: [{ $ref: "#/components/schemas/ProblemDetails" }, {
	type: "object",
	properties: {
		type: {
			type: "string",
			enum: ["urn:problem:invalid-request-syntax"],
			description: "A URI reference that identifies the problem type."
		},
		status: {
			type: "number",
			enum: [400],
			description: "The HTTP status code generated by the origin server."
		},
		errors: {
			type: "array",
			items: {
				type: "object",
				properties: {
					detail: {
						type: "string",
						minLength: 1,
						maxLength: 5e3
					},
					pointer: {
						type: "string",
						minLength: 1,
						maxLength: 200,
						description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)."
					}
				},
				required: ["detail", "pointer"]
			},
			minItems: 1,
			description: "Detailed information regarding the syntactic violations."
		}
	},
	required: ["errors"]
}] }, h = (e, t) => {
	let n = e.message;
	if (n) switch (n.case) {
		case d.ProductCreated:
			t.onCreated?.(n.value);
			break;
		case d.ProductUpdated: t.onUpdated?.(n.value);
	}
}, g = /* @__PURE__ */ ye({}), _ = {
	ContainsDangerousSubstances: "containsDangerousSubstances",
	HasUnlimitedShelfLife: "hasUnlimitedShelfLife"
}, v = {
	G: "g",
	KG: "kg"
}, y = { CM: "cm" }, b = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18,
	Spring: 19,
	ViaTim: 20,
	DhlFreight: 21
}, x = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	Spring: "spring",
	SPRING: "SPRING",
	ViaTim: "viatim",
	VIA_TIM: "VIA_TIM",
	DhlFreight: "dhlfreight",
	DHL_FREIGHT: "DHL_FREIGHT"
};
b.Dhl, b.Instabox, b.PostNl, x.PostNl, b.Bpost, x.Bpost, b.CheapCargo, x.CheapCargo, b.Dpd, x.Dpd, b.Instabox, x.Instabox, b.Dhl, x.Dhl, b.Bol, x.Bol, b.Ups, x.Ups, b.DhlForYou, x.DhlForYou, b.DhlParcelConnect, x.DhlParcelConnect, b.DhlEuroPlus, x.DhlEuroPlus, b.UpsStandard, x.UpsStandard, b.UpsExpressSaver, x.UpsExpressSaver, b.Gls, x.Gls, b.Brt, x.Brt, b.Trunkrs, x.Trunkrs, b.InPost, x.InPost, b.PosteItaliane, x.PosteItaliane, b.Spring, x.Spring, b.ViaTim, x.ViaTim, b.DhlFreight, x.DhlFreight, b.PostNl, x.POSTNL, b.Bpost, x.BPOST, b.CheapCargo, x.CHEAP_CARGO, b.Dpd, x.DPD, b.Instabox, x.INSTABOX, b.Dhl, x.DHL, b.Bol, x.BOL, b.Ups, x.UPS, b.DhlForYou, x.DHL_FOR_YOU, b.DhlParcelConnect, x.DHL_PARCEL_CONNECT, b.DhlEuroPlus, x.DHL_EUROPLUS, b.UpsStandard, x.UPS_STANDARD, b.UpsExpressSaver, x.UPS_EXPRESS_SAVER, b.Gls, x.GLS, b.Brt, x.BRT, b.Trunkrs, x.TRUNKRS, b.InPost, x.INPOST, b.PosteItaliane, x.POSTE_ITALIANE, b.Spring, x.SPRING, b.ViaTim, x.VIA_TIM, b.DhlFreight, x.DHL_FREIGHT, x.POSTNL, b.PostNl, x.BPOST, b.Bpost, x.CHEAP_CARGO, b.CheapCargo, x.DPD, b.Dpd, x.INSTABOX, b.Instabox, x.DHL, b.Dhl, x.BOL, b.Bol, x.UPS, b.Ups, x.DHL_FOR_YOU, b.DhlForYou, x.DHL_PARCEL_CONNECT, b.DhlParcelConnect, x.DHL_EUROPLUS, b.DhlEuroPlus, x.UPS_STANDARD, b.UpsStandard, x.UPS_EXPRESS_SAVER, b.UpsExpressSaver, x.GLS, b.Gls, x.BRT, b.Brt, x.TRUNKRS, b.Trunkrs, x.INPOST, b.InPost, x.POSTE_ITALIANE, b.PosteItaliane, x.SPRING, b.Spring, x.VIA_TIM, b.ViaTim, x.DHL_FREIGHT, b.DhlFreight, x.PostNl, b.PostNl, x.POSTNL, b.PostNl, x.Bpost, b.Bpost, x.BPOST, b.Bpost, x.CheapCargo, b.CheapCargo, x.CHEAP_CARGO, b.CheapCargo, x.Dpd, b.Dpd, x.DPD, b.Dpd, x.Instabox, b.Instabox, x.Dhl, b.Dhl, x.BolCom, b.Bol, x.Bol, b.Bol, x.BOL, b.Bol, x.Ups, b.Ups, x.DhlForYou, b.DhlForYou, x.DHL_FOR_YOU, b.DhlForYou, x.DhlParcelConnect, b.DhlParcelConnect, x.DHL_PARCEL_CONNECT, b.DhlParcelConnect, x.DhlEuroPlus, b.DhlEuroPlus, x.DHL_EUROPLUS, b.DhlEuroPlus, x.UpsStandard, b.UpsStandard, x.UPS_STANDARD, b.UpsStandard, x.UpsExpressSaver, b.UpsExpressSaver, x.UPS_EXPRESS_SAVER, b.UpsExpressSaver, x.Gls, b.Gls, x.GLS, b.Gls, x.Brt, b.Brt, x.BRT, b.Brt, x.Trunkrs, b.Trunkrs, x.TRUNKRS, b.Trunkrs, x.InPost, b.InPost, x.INPOST, b.InPost, x.PosteItaliane, b.PosteItaliane, x.POSTE_ITALIANE, b.PosteItaliane, x.Spring, b.Spring, x.SPRING, b.Spring, x.ViaTim, b.ViaTim, x.VIA_TIM, b.ViaTim, x.DhlFreight, b.DhlFreight, x.DHL_FREIGHT, b.DhlFreight, b.PostNl, b.Bpost, b.CheapCargo, b.Dpd, b.Instabox, b.Dhl, b.Bol, b.Ups, b.DhlForYou, b.DhlParcelConnect, b.DhlEuroPlus, b.UpsStandard, b.UpsExpressSaver, b.Gls, b.Brt, b.Trunkrs, b.InPost, b.PosteItaliane, b.Spring, b.ViaTim, b.DhlFreight;
var S = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
};
S.Austria, S.Belgium, S.Bulgaria, S.Croatia, S.Cyprus, S.CzechRepublic, S.Denmark, S.Estonia, S.Finland, S.France, S.Germany, S.Greece, S.Hungary, S.Ireland, S.Italy, S.Latvia, S.Lithuania, S.Luxembourg, S.Malta, S.Netherlands, S.Poland, S.Portugal, S.Romania, S.Slovakia, S.Slovenia, S.Spain, S.Sweden, Object.values(S), S.Angola, S.AntiguaAndBarbuda, S.Aruba, S.Bahamas, S.Belize, S.Benin, S.Bermuda, S.BonaireSintEustatiusAndSaba, S.Botswana, S.BurkinaFaso, S.Burundi, S.Cameroon, S.CanaryIslands, S.CentralAfricanRepublic, S.Comoros, S.CongoBrazzaville, S.CongoKinshasa, S.CoteDIvoire, S.Curacao, S.Djibouti, S.Dominica, S.DutchAntilles, S.EquatorialGuinea, S.Eritrea, S.Fiji, S.Gabon, S.Gambia, S.Ghana, S.Grenada, S.Guyana, S.HongKong, S.Kiribati, S.KoreaPeoplesDemocraticRepublic, S.Macao, S.Malawi, S.Mali, S.Mauritania, S.Nauru, S.Qatar, S.Rwanda, S.SaintKittsAndNevis, S.SaoTomeAndPrincipe, S.Seychelles, S.SierraLeone, S.SintMaarten, S.Suriname, S.SyrianArabRepublic, S.TimorLeste, S.Togo, S.Tonga, S.Tuvalu, S.Uganda, S.UnitedArabEmirates, S.Vanuatu, S.Yemen, S.Zimbabwe, S.Austria, S.Belgium, S.Bulgaria, S.Croatia, S.CzechRepublic, S.Estonia, S.Finland, S.France, S.Germany, S.Greece, S.Hungary, S.Ireland, S.Italy, S.Latvia, S.Lithuania, S.Luxembourg, S.Malta, S.Netherlands, S.Portugal, S.Romania, S.Slovakia, S.Slovenia, S.Spain, S.UnitedKingdom, S.Denmark, S.Germany, S.Sweden;
var C = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
}, w = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
}, T = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
};
C.EarlyMorning, w.EarlyMorning, C.Morning, w.Morning, C.Standard, w.Standard, C.Evening, w.Evening, C.Pickup, w.Pickup, C.PickupExpress, w.PickupExpress, C.SameDayDelivery, w.SameDayDelivery, C.Express, w.Express, w.EarlyMorning, C.EarlyMorning, w.Morning, C.Morning, w.Standard, C.Standard, w.Evening, C.Evening, w.Pickup, C.Pickup, w.PickupExpress, C.PickupExpress, w.SameDayDelivery, C.SameDayDelivery, w.Express, C.Express, C.EarlyMorning, T.EarlyMorning, C.Morning, T.Morning, C.Standard, T.Standard, C.Evening, T.Evening, C.Pickup, T.Pickup, C.PickupExpress, T.PickupExpress, C.SameDayDelivery, T.SameDayDelivery, C.Express, T.Express, T.EarlyMorning, w.EarlyMorning, T.Morning, w.Morning, T.Standard, w.Standard, T.Evening, w.Evening, T.Pickup, w.Pickup, T.PickupExpress, w.PickupExpress, T.SameDayDelivery, w.SameDayDelivery, T.Express, w.Express, C.EarlyMorning, C.Morning, C.Standard, C.Evening, C.Pickup, C.PickupExpress, C.SameDayDelivery, C.Express, { Vasco: 1 }.Vasco, { Vasco: "vasco" }.Vasco;
var E = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
}, D = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
};
D.Sunday, E.Sunday, D.Monday, E.Monday, D.Tuesday, E.Tuesday, D.Wednesday, E.Wednesday, D.Thursday, E.Thursday, D.Friday, E.Friday, D.Saturday, E.Saturday, E.Sunday, D.Sunday, E.Monday, D.Monday, E.Tuesday, D.Tuesday, E.Wednesday, D.Wednesday, E.Thursday, D.Thursday, E.Friday, D.Friday, E.Saturday, D.Saturday;
var O = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
};
O.Bytes, O.Kilobytes, O.Megabytes, O.Gigabytes, O.Terabytes;
var k = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
}, A = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
};
k.Bol, A.Bol, k.Exact, A.Exact, k.Amazon, A.Amazon, k.Wix, A.Wix, k.ExactDe, A.ExactDe, k.Etsy, A.Etsy, A.Bol, k.Bol, A.Exact, k.Exact, A.Amazon, k.Amazon, A.Wix, k.Wix, A.ExactDe, k.ExactDe, A.Etsy, k.Etsy;
var j = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
}, M = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
};
j.Unpaid, M.Unpaid, j.Due, M.Due, j.DuePrepayment, M.DuePrepayment, j.Reminder1, M.Reminder1, j.Reminder2, M.Reminder2, j.Dun, M.Dun, j.Collection, M.Collection, j.Instalments, M.Instalments, j.PaymentArrangement, M.PaymentArrangement, j.Dispute, M.Dispute, j.LegalProcedure, M.LegalProcedure, j.Insolvency, M.Insolvency, j.WriteOff, M.WriteOff, j.Pending, M.Pending, j.Cancelled, M.Cancelled, j.Paid, M.Paid, j.PaidOnline, M.PaidOnline, j.PaidAutomatic, M.PaidAutomatic, j.PaidCredit, M.PaidCredit, j.PaidZeroItems, M.PaidZeroItems, j.InvoiceWith0InvoiceItemsPaidZeroBalance, M.PaidZeroBalance, j.Due, j.Reminder1, j.Reminder2, j.Dun, j.Collection, j.Instalments, j.PaymentArrangement, j.Dispute, j.Paid, j.PaidOnline, j.PaidAutomatic, j.PaidCredit, j.PaidZeroItems;
var N = {
	Gram: "g",
	Kilogram: "kg"
};
N.Gram, N.Kilogram;
var P = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
};
P.Millimeter, P.Centimeter, P.Meter;
var F = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
}, I = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnRouteHandedToCarrier: 3,
	EnRouteSorting: 4,
	EnRouteDistribution: 5,
	EnRouteCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedLetter: 12,
	InactiveCredited: 13,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnRouteHandedToCarrier: 32,
	InactiveEnRouteSorting: 33,
	InactiveEnRouteDistribution: 34,
	InactiveEnRouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38
};
I.PendingConcept, I.PendingRegistered, I.EnRouteHandedToCarrier, I.EnRouteSorting, I.EnRouteDistribution, I.EnRouteCustoms, I.DeliveredReadyForPickup, I.DeliveredAtRecipient, I.DeliveredPackagePickedUp;
var L = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
}, R = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
};
R.Light, L.Light, R.Start, L.Start, R.Plus, L.Plus, R.Premium, L.Premium, R.Max, L.Max, L.Light, R.Light, L.Start, R.Start, L.Plus, R.Plus, L.Premium, R.Premium, L.Max, R.Max;
var z = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
}, B = {
	Start: L.Start,
	Plus: L.Plus,
	Premium: L.Premium,
	Max: L.Max
};
z.Start, B.Start, z.Plus, B.Plus, z.Premium, B.Premium, z.Max, B.Max, B.Start, z.Start, B.Plus, z.Plus, B.Premium, z.Premium, B.Max, z.Max;
var V = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
}, H = {
	Start: L.Start,
	Plus: L.Plus,
	Premium: L.Premium,
	Max: L.Max
};
V.Start, H.Start, V.Plus, H.Plus, V.Premium, H.Premium, V.Max, H.Max, H.Start, V.Start, H.Plus, V.Plus, H.Premium, V.Premium, H.Max, V.Max;
var U = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
}, W = {
	Light: L.Light,
	Start: L.Start,
	Plus: L.Plus,
	Premium: L.Premium,
	Max: L.Max
};
U.Light, W.Light, U.Start, W.Start, U.Plus, W.Plus, U.Premium, W.Premium, U.Max, W.Max, W.Light, U.Light, W.Start, U.Start, W.Plus, U.Plus, W.Premium, U.Premium, W.Max, U.Max;
var G = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
}, K = {
	Start: L.Start,
	Plus: L.Plus,
	Premium: L.Premium,
	Max: L.Max
};
G.Start, K.Start, G.Plus, K.Plus, G.Premium, K.Premium, G.Max, K.Max, K.Start, G.Start, K.Plus, G.Plus, K.Premium, G.Premium, K.Max, G.Max;
var q = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
}, J = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
}, Y = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
};
q.MyParcel, J.MyParcel, q.Flespakket, J.Flespakket, q.SendMyParcel, J.SendMyParcel, q.MyParcelIt, J.MyParcelIt, q.DeliverDutch, J.DeliverDutch, q.PostNlPlugin, J.PostNlPlugin, q.MyParcel, Y.MyParcelNl, q.Flespakket, Y.MyParcelNl, q.SendMyParcel, Y.MyParcelBe, q.MyParcelIt, Y.MyParcelIt, q.DeliverDutch, Y.DeliverDutch, q.PostNlPlugin, Y.PostNlPlugin, Y.MyParcelNl, q.MyParcel, Y.MyParcelBe, q.SendMyParcel, Y.MyParcelIt, q.MyParcelIt, Y.MyParcelNl, F.HomeCountry, S.Netherlands, F.Eu, F.Row, S.Belgium, Y.MyParcelBe, F.HomeCountry, S.Belgium, S.Netherlands, F.Eu, F.Row, Y.MyParcelBe, F.HomeCountry, S.Belgium, F.Eu, F.Row, Y.MyParcelNl, F.HomeCountry, S.Netherlands, F.Eu, F.Row, Y.MyParcelNl, F.HomeCountry, S.Netherlands, S.Belgium, S.Luxembourg, b.Bpost, b.PostNl, b.DhlForYou, b.DhlParcelConnect, b.DhlEuroPlus, b.Ups, b.UpsStandard, b.UpsExpressSaver;
var X = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
}, Z = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
};
X.Package, Z.Package, X.Mailbox, Z.Mailbox, X.Letter, Z.Letter, X.DigitalStamp, Z.DigitalStamp, X.Pallet, Z.Pallet, X.PackageSmall, Z.PackageSmall, X.Envelope, Z.Envelope, Z.Package, X.Package, Z.Mailbox, X.Mailbox, Z.Letter, X.Letter, Z.DigitalStamp, X.DigitalStamp, Z.Pallet, X.Pallet, Z.PackageSmall, X.PackageSmall, Z.Envelope, X.Envelope;
var Q = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
};
X.Package, Q.PACKAGE, X.Mailbox, Q.MAILBOX, X.Letter, Q.UNFRANKED, X.DigitalStamp, Q.DIGITAL_STAMP, X.Pallet, Q.PALLET, X.PackageSmall, Q.SMALL_PACKAGE, X.Envelope, Q.ENVELOPE, Q.PACKAGE, X.Package, Q.MAILBOX, X.Mailbox, Q.UNFRANKED, X.Letter, Q.DIGITAL_STAMP, X.DigitalStamp, Q.PALLET, X.Pallet, Q.SMALL_PACKAGE, X.PackageSmall, Q.ENVELOPE, X.Envelope, X.Package, X.Mailbox, X.Letter, X.DigitalStamp, X.Pallet, X.PackageSmall, X.Envelope;
var $ = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
};
$.PendingConcept, $.PendingRegistered, $.EnrouteHandedToCarrier, $.EnrouteSorting, $.EnrouteDistribution, $.DeliveredAtCustoms, $.DeliveredAtRecipient, $.DeliveredPackagePickedUp, $.DeliveredReturnShipmentPackagePickedUp, $.DeliveredAtAgreedLocation, $.PrintedLetter, $.PrintedDigitalStamp, $.InactiveConcept, $.InactiveRegistered, $.InactiveEnrouteHandedToCarrier, $.InactiveEnrouteSorting, $.InactiveEnrouteDistribution, $.InactiveEnrouteCustoms, $.InactiveDeliveredAtRecipient, $.InactiveDeliveredReadyForPickup, $.InactiveDeliveredPackagePickedUp;
//#endregion
//#region src/utils/weight.ts
var ke = (e, t) => {
	let n;
	switch (t) {
		case N.Gram:
			n = e;
			break;
		default: n = f.getWeightFactor(t) * e;
	}
	return {
		value: n,
		unit: "g"
	};
}, Ae = (e) => {
	switch (e.unit) {
		case "g": return e.value;
		case "kg": return e.value * f.getWeightFactor(N.Kilogram);
	}
}, { currency: { format: je } } = ge, Me = ({ currency: e, micros: t }) => je(Math.floor(t / 1e4), { currency: e });
//#endregion
export { he as FulfilmentPlatform, be as FulfilmentPlatformSchema, m as ProblemDetailsInvalidRequestSyntaxSchema, Oe as ProblemDetailsSchema, pe as ProductAggregation, xe as ProductAggregationSchema, Se as ProductIdSchema, De as ProductSchema, me as ProductStatus, Ce as ProductStatusSchema, we as ShopIdSchema, _e as SortDirection, Te as SortDirectionSchema, Ee as StockSchema, _ as characteristics, g as events, Me as fullPrice, se as getProducts, Ae as mapServiceWeightToGrams, ke as mapWeightToService, h as matchProductEvent, u as postCreateProduct, ae as postManageInventory, s as postUpdateProduct, ue as productApiAcceptanceUrl, t as productApiUrl, y as sizeUnit, ve as useProductService, v as weightUnit, r as zFulfilmentPlatform, re as zGetProductsData, oe as zGetProductsResponse, te as zPostCreateProductData, c as zPostCreateProductResponse, ce as zPostManageInventoryData, ne as zPostManageInventoryResponse, i as zPostUpdateProductData, ie as zPostUpdateProductResponse, l as zProblemDetails, o as zProblemDetailsInvalidRequestSyntax, a as zProduct, n as zProductAggregation, le as zProductId, fe as zProductStatus, ee as zShopId, de as zSortDirection, e as zStock };
